<template>
    <div class="section is-relative" id="store-switcher">
        <b-loading :is-full-page="false" :active="loading"></b-loading>
        <b-field horizontal label="Select Store">
            <b-select v-model="currentStore" expanded @input="changeStore">
                <optgroup v-for="website in websites"
                        :key="`website-${website.id}`"
                        :label="website.name">
                    <option v-for="store in website.stores"
                            :key="`website-${website.id}-store-${store.id}`"
                            :value="store" v-text="store.name"></option>
                </optgroup>
            </b-select>
        </b-field>
    </div>
</template>
<script>
    export default {
        props: {
            routeName: {
                required: true,
                type: String
            },
            routeParams: {
                required: false,
                type: Object
            },
            useQuery: {
                required: false,
                type: Boolean,
                default: false
            },
            sendWebsite: {
                required: false,
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                websites: [],
                loading: true,
                currentStore: null,
                inited: false
            }
        },
        mounted() {
            axios.get('/website/index', {params: {paginate: false}})
                .then(response => {
                    this.websites = response.data;
                    this.currentStore = _.find(this.websites[0].stores, {id: 1});
                    let key = 'params';
                    if (this.useQuery) {
                        key = 'query'
                    }

                    if (this.$route[key].hasOwnProperty('store')) {
                        let website = _.find(this.websites, {stores: [{id: parseInt(this.$route[key].store)}]})
                        this.currentStore = _.find(website.stores, {id: parseInt(this.$route[key].store)});
                    }
                    this.loading = false;
                    this.inited = true;
                })
        },
        methods: {
            changeStore() {
                let route = {name: this.routeName};
                let key = this.useQuery ? 'query' : 'params';
                let routeKeys = {store: this.currentStore.id};
                if (this.sendWebsite) {
                    routeKeys['website'] = this.currentStore.website_id === 1 ? 2 : this.currentStore.website_id;
                }
                route[key] = Object.assign({}, this.routeParams, routeKeys);
                this.$router.push(route);
                this.$emit('changed-store', this.currentStore)
            }
        }
    }
</script>